import { createAction, GLOBALS, type CommonThunkAction } from '@wix/communities-blog-client-common';

export const ADD_TEXT_COLOR_REQUEST = 'rceSettings/ADD_TEXT_COLOR_REQUEST';
export const ADD_TEXT_COLOR_SUCCESS = 'rceSettings/ADD_TEXT_COLOR_SUCCESS';
export const ADD_TEXT_COLOR_FAILURE = 'rceSettings/ADD_TEXT_COLOR_FAILURE';
export const addTextColorRequest = createAction(ADD_TEXT_COLOR_REQUEST);
export const addTextColorSuccess = createAction(ADD_TEXT_COLOR_SUCCESS);
export const addTextColorFailure = createAction(ADD_TEXT_COLOR_FAILURE);

export const addTextColor =
  (color: string): CommonThunkAction<Promise<void>> =>
  async (dispatch, _, { httpClient, errorHandler }) => {
    dispatch(addTextColorRequest({ color }));

    const { withErrorHandler, showError } = errorHandler;

    try {
      const { data: rceSettings } = await withErrorHandler(
        () => httpClient.post(`${GLOBALS.API_BASE_URL_CLIENT}/_api/rce-settings`, { color }),
        { errorCodesMap: {} },
      );
      dispatch(addTextColorSuccess({ rceSettings }));
    } catch (error) {
      showError(error);
      dispatch(addTextColorFailure());
    }
  };

export const FETCH_RCE_SETTINGS_REQUEST = 'rceSettings/FETCH_REQUEST';
export const FETCH_RCE_SETTINGS_SUCCESS = 'rceSettings/FETCH_SUCCESS';
export const FETCH_RCE_SETTINGS_FAILURE = 'rceSettings/FETCH_FAILURE';
export const fetchRceSettingsRequest = createAction(FETCH_RCE_SETTINGS_REQUEST);
export const fetchRceSettingsSuccess = createAction(FETCH_RCE_SETTINGS_SUCCESS);
export const fetchRceSettingsFailure = createAction(FETCH_RCE_SETTINGS_FAILURE);

export const fetchRceSettings =
  (): CommonThunkAction<Promise<void>> =>
  async (dispatch, _, { httpClient, errorHandler }) => {
    dispatch(fetchRceSettingsRequest());

    const { withErrorHandler, showError } = errorHandler;

    try {
      const { data: rceSettings } = await withErrorHandler(
        () => httpClient.get(`${GLOBALS.API_BASE_URL_CLIENT}/_api/rce-settings`),
        { errorCodesMap: {} },
      );
      dispatch(fetchRceSettingsSuccess({ rceSettings }));
    } catch (error) {
      showError(error);
      dispatch(fetchRceSettingsFailure());
    }
  };
